import { del, get, patch, put, post } from "./api";

export interface ViewConfig {
  id: string;
  type: "customui" | "workspace";
  name: string;
  description?: string;
  thumbnail?: string;
  adminLevel?: "admin" | "facilitator" | "none" | "hidden";
  config?: CustomConfig | WorkspaceConfig;
  transforms: [];
  layout: any;
  animationStrategy: "static" | "internalClock" | "externalTick";
  userStyling?: Record<string, string>;
  notes?: [];
  nodeNotes?: [];
  version: string;
  // Metadata
  createdBy?: string;
  createdAt?: string;
}

export interface CustomConfig {
  detail: string[];
  controls: Controls[];
}

export interface WorkspaceConfig {
  detail: string[];
}

export interface Controls {
  id: string;
  title: string;
  description: string;
  detail: string;
  dataSource: "nodes" | "links";
  propertyKey: string;
  dataFilter?: {
    propertyKey?: string;
    values?: any[];
  };
  values?: any[];
  buttonConfig: {
    useColours: boolean;
    trueText: string;
    falseText: string;
    multiSelect: boolean;
  };
  transformTargets: TransformTarget[];
  validateAtTransform?: string;
}

export interface TransformTarget {
  transformTarget: string;
  transformPath: string;
}

export interface ViewResponse {
  data: ViewConfig[];
  success: boolean;
  message?: string;
}

//this is all they can update at the moment
export interface ViewUpdate {
  name?: string;
  description?: string;
  adminLevel?: "admin" | "facilitator" | "none" | "hidden";
}

export const getViews = async (projectId: string): Promise<ViewConfig[]> => {
  try {
    const url = `/projects/${projectId}/view`;
    const response = await get(url);
    console.log("Raw view response:", response);

    // Handle different response formats
    if (response.data && Array.isArray(response.data)) {
      // Ensure each view has an ID
      return response.data.map((view, index) => ({
        ...view,
        id: view._id || view.id,
      }));
    } else if (Array.isArray(response)) {
      // Ensure each view has an ID
      return response.map((view, index) => ({
        ...view,
        id: view._id || view.id,
      }));
    } else {
      console.warn("Unexpected view response format", response);
      return [];
    }
  } catch (error) {
    console.error("Error fetching view:", error);
    throw error;
  }
};

export const deleteView = async (
  projectId: string,
  viewId: string
): Promise<void> => {
  try {
    const url = `/projects/${projectId}/view/${viewId}`;
    const response = await del(url);
    console.log("Deleted view", response);
    return response;
  } catch (error) {
    console.error("Error view workspace:", error);
    throw error;
  }
};

export const updateView = async (
  projectId: string,
  viewId: string,
  viewData: ViewUpdate
): Promise<ViewConfig> => {
  try {
    const url = `/projects/${projectId}/view/${viewId}`;
    const response = await patch(url, viewData);
    console.log("Updated view", response);
    return response.data || response;
  } catch (error) {
    console.error("Error updating view:", error);
    throw error;
  }
};

export const getView = async (
  projectId: string,
  viewId: string
): Promise<ViewConfig> => {
  try {
    const url = `/projects/${projectId}/view/${viewId}`;
    const response = await get(url);
    console.log("Fetched view", response);
    return response.data || response;
  } catch (error) {
    console.error("Error fetching view:", error);
    throw error;
  }
};
